import { render, staticRenderFns } from "./Stationscore.vue?vue&type=template&id=157b9666&scoped=true&"
import script from "./Stationscore.vue?vue&type=script&lang=js&"
export * from "./Stationscore.vue?vue&type=script&lang=js&"
import style0 from "./Stationscore.vue?vue&type=style&index=0&id=157b9666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157b9666",
  null
  
)

export default component.exports